import * as Types from '../Constants/AllConstants';

export const readNotificationReducer = (state = { notification: {} }, action) => {
  switch (action.type) {
    case Types.NOTIFICATION_DETAILS_REQUEST:
      return { loading: true };
    case Types.NOTIFICATION_DETAILS_SUCCESS:
      return { loading: false, report: action.payload };
    case Types.NOTIFICATION_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};


export const readAllNotificationsReducer = (state = { notification: {} }, action) => {
  switch (action.type) {
    case Types.NOTIFICATION_READ_ALL_REQUEST:
      return { loading: true };
    case Types.NOTIFICATION_READ_ALL_SUCCESS:
      return { loading: false, notification: action.payload };
    case Types.NOTIFICATION_READ_ALL_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};


export const getNotificationReducer = (state = { notification: {} }, action) => {
  switch (action.type) {
    case Types.NOTIFICATION_DETAILS_REQUEST:
      return { loading: true };
    case Types.NOTIFICATION_DETAILS_SUCCESS:
      return { loading: false, notification: action.payload };
    case Types.NOTIFICATION_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};


export const NotificationsListReducer = (
  state = { notifications: [], pages: 0, page: 0, loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.NOTIFICATION_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.NOTIFICATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.pageable.pageNumber,
      };
    case Types.NOTIFICATION_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };
    case Types.NOTIFICATION_LIST_RESET:
      return { notifications: [], pages: 0, page: 0, loading: false, error: null };
    default:
      return state;
  }
};

export const DeleteNotificationReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.DELETE_NOTIFICATION_REQUEST:
      return { loading: true };
    case Types.DELETE_NOTIFICATION_SUCCESS:
      return { loading: false, success: true };
    case Types.DELETE_NOTIFICATION_FAIL:
      return { loading: false, error: action.payload };
    case Types.DELETE_NOTIFICATION_RESET:
      return {};
    default:
      return state;
  }
};

export const DeleteAllNotificationReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.DELETE_NOTIFICATION_REQUEST:
      return { loading: true };
    case Types.DELETE_NOTIFICATION_SUCCESS:
      return { loading: false, success: true };
    case Types.DELETE_NOTIFICATION_FAIL:
      return { loading: false, error: action.payload };
    case Types.DELETE_NOTIFICATION_RESET:
      return {};
    default:
      return state;
  }
};